import React from 'react';
import { cn } from '@/lib/utils';
import Icon, { IconComponent } from './Icon';

interface NoteProps {
  icon: IconComponent;
  tone?: 'brand' | 'warning';
  children: React.ReactNode;
  className?: string;
}

/** Compact one-line tinted note inside a card, e.g. "Protection available till 27 Nov 2026". */
const Note: React.FC<NoteProps> = ({ icon, tone = 'brand', children, className }) => (
  <p
    className={cn(
      'tw-flex tw-items-center tw-gap-2 tw-rounded-[10px] tw-px-2.5 tw-py-2 tw-text-[12px] tw-font-medium tw-leading-4',
      tone === 'brand' ? 'tw-bg-ds-brand-tint tw-text-ds-brand-text' : 'tw-bg-ds-warning-bg tw-text-ds-warning-fg',
      className,
    )}
  >
    <Icon icon={icon} size={14} />
    <span className="tw-min-w-0 tw-flex-1">{children}</span>
  </p>
);

export default Note;
